import * as React from 'react'
import { YellowBaloon } from '../Icons'
import './index.scss'

const Loading = () => (
    <div className="decode-loading">
        <YellowBaloon />
    </div>
)

export default Loading


// WEBPACK FOOTER //
// ./src/components/common/Loading/index.tsx